import { defineMessages } from '@edx/frontend-platform/i18n';

export default defineMessages({
  expandAltText: {
    id: 'authoring.sharedComponents.collapsibleFormWidget.expand',
    defaultMessage: 'Expand',
    description: 'Accessible label for button which expands a form section.',
  },
  collapseAltText: {
    id: 'authoring.sharedComponents.collapsibleFormWidget.collapse',
    defaultMessage: 'Collapse',
    description: 'Accessible label for button which collapses a form section.',
  },
});
